import { SubtotalLineItemSchema } from '@eigtech/line-items';
import { JobCornSchema } from '@eigtech/restoration-types';
import { z } from 'zod';
import { RegionCornSchema } from '../../base/index.js';
export const CalculateEmsTarpingInvoiceApiSchema = {
    params: z.object({
        jobId: JobCornSchema,
        regionId: RegionCornSchema,
    }),
    response: z.object({
        invoice: SubtotalLineItemSchema,
    }),
};
